import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';

import { FlashyTokenService, UserStore } from '@flashy/users/data-access';
import { RedirectManagerService } from '@services/app/redirect-manager.service';

import { AccountStore } from 'account/data-access';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  accountStore = inject(AccountStore);
  userStore = inject(UserStore);

  constructor(
    readonly tokenService: FlashyTokenService,
    private router: Router,
    private redirectManagerService: RedirectManagerService
  ) {}

  // A workaround resolver
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (next.queryParamMap.has('token')) {
      this.tokenService.token = next.queryParamMap.get('token');
      return this.router.createUrlTree([location.pathname]);
    }

    sessionStorage.setItem('redirect', state.url);

    const needAuthentication = this.userStore.needAuthentication();
    if (needAuthentication) {
      const { pathname, search } = location;
      const url = pathname + search;
      if (url.includes('/dash')) {
        this.redirectManagerService.registerRedirect(url);
      }

      return this.router.parseUrl('/verify');
    }

    const isAuthorized = this.userStore.isAuthorized();
    if (!isAuthorized) {
      const { pathname, search } = location;
      const url = pathname + search;
      if (url.includes('/dash')) {
        this.redirectManagerService.registerRedirect(url);
      }
      return this.router.parseUrl('/auth');
    }

    return from(this.accountStore.getAccounts()).pipe(
      map(() => {
        if (
          this.accountStore.entities().length === 1 &&
          state.url === '/dash'
        ) {
          const [{ account, redirect = 'overview' }] =
            this.accountStore.entities();
          return this.router.createUrlTree(['dash', account, redirect]);
        }
        return true;
      })
    );
  }
}
